import React from "react";

const CourseCodeInput = (props) => {
  let input;
  const keyArr = props.inputKey.split("-");
  switch (props.inputType) {
    case "subj":
      const subjOpts = props.subjects.map((s) => (
        <option key={props.inputKey + "inputopt" + s.id} value={s.id}>
          {s.name}
        </option>
      ));
      input = (
        <select
          id={props.inputKey + "input"}
          style={{ width: "10rem", height: "3rem", fontSize: "2rem" }}
          value={props.value}
          onChange={(e) => props.handleChange({ type: "subject_lookup_id" }, e)}
          className="sm-buffer-right"
        >
          {subjOpts}
        </select>
      );
      break;
    case "text":
      input = (
        <input
          id={props.inputKey + "input"}
          type="text"
          style={{ width: "3rem", height: "3rem", fontSize: "2rem" }}
          value={props.value}
          maxLength="1"
          onChange={(e) =>
            props.handleChange({ keyStr: keyArr[0], keyNum: keyArr[1] }, e)
          }
          className="sm-buffer-right"
        />
      );
      break;
    default:
      input = (
        <input
          id={props.inputKey + "input"}
          style={{ width: "3rem", height: "3rem", fontSize: "2rem" }}
          type="number"
          min="0"
          max="9"
          maxLength="1"
          value={props.value}
          onChange={(e) =>
            props.handleChange({ keyStr: keyArr[0], keyNum: keyArr[1] }, e)
          }
          className="sm-buffer-right"
        />
      );
  }
  return input;
};

export default CourseCodeInput;
